import { lazy } from 'react';

// react-grid-layout is only needed to move events: Ctrl + drag within a day, and the day window. It loads
// in a chunk of its own; the calendar starts fetching it next to its data, so it's normally there before
// anyone needs it.
const load = () => import('react-grid-layout');
const library = (module) => (module.Responsive ? module : module.default);

export const preloadGridLayout = () => { load(); };

export const Responsive = lazy(() => load().then((module) => ({ default: library(module).Responsive })));

export const ResponsiveWithWidth = lazy(() => load().then((module) => {
    const { Responsive: ResponsiveGrid, WidthProvider } = library(module);
    return { default: WidthProvider(ResponsiveGrid) };
}));
